var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    model: {
      value: _vm.category,
      callback: function ($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  }, 'v-select', Object.assign({}, _vm.$attrs, {
    items: _vm.items
  }), false));

}
var staticRenderFns = []

export { render, staticRenderFns }